import React from "react";

export function Logo({ className = "", showText = true }) {
    return (
        <div className={`inline-flex items-center gap-2 ${className}`} data-testid="bl-logo">
            <span className="relative inline-flex h-8 w-8 items-center justify-center rounded-xl shadow-soft" style={{
                background: "linear-gradient(135deg,#0B2B40 0%,#007A8A 60%,#00A3B5 100%)",
            }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 17c2.5-3 5-3 8-1s5.5 2 10-1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M3 11c2.5-3 5-3 8-1s5.5 2 10-1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" opacity=".7" />
                </svg>
            </span>
            {showText && (
                <span className="font-heading text-lg font-semibold tracking-tight text-ocean-700">
                    Blue<span className="text-secondary">Ledger</span>
                </span>
            )}
        </div>
    );
}

export default Logo;
